/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable max-len */
import React, { useEffect, useState } from 'react'
import Link from 'next/link'
import Typography from '@material-ui/core/Typography'
import CardContent from '@material-ui/core/CardContent'
import { Button, Card, Box } from '@material-ui/core'
import Image from 'next/image'

import { useRouter } from 'next/router'
import CardActions from '@material-ui/core/CardActions'

import { useProfileDetailsStyles } from './profile-details.styles'
import {
  SERVICES_URL,
  useLocale,
  useQueryUser,
  useTranslation
} from '@plandi/common'

import OnlineIcon from '../../assets/svg-components/on-line'
// import { ReactComponent as CrownIcon } from '../../assets/crown.svg'
import {
  useQueryMyProfileCompany,
  useQueryMyProfileFactory,
  useQueryMyProfileFreelancer
} from 'src/common'
import { ReviewsModal } from 'src/common/reviews-modal'
import { ContactFormSkeleton } from '../contacts/contact-form/contact-form-skeleton'
import { useFormikContext } from 'formik'
import { ProfileContactsUser } from './profile-contacts-user'
import { ProfilePublications } from './profile-publications'
import { ProfileInfo } from './profile-info'
import { ProfileAbout } from './profile-about'
import { ProfileEmployment } from './profile-employment'
import { ProfileFeatures } from './profile-features'
import { ProfileSpeciality } from './profile-speciality'
import { ProfileProfessional } from './profile-professional'
import { ProfileStructure } from './profile-structure'
import { ProfileSocial } from './profile-social'

type ProfileDetailsProps = {
  userPage?: boolean
  profileType?: string
  loadingProfile?: boolean
  create?: boolean
  projectsProfile?: any
}

export const ProfileDetails: React.FC<ProfileDetailsProps> = (props) => {
  const [isReviewsModalOpened, setIsReviewsModalOpened] = useState(false)
  const locale = useLocale()
  const url = SERVICES_URL
  const { data: translate } = useTranslation()
  const router = useRouter()
  const type = router.query.type || props.profileType
  // const userId = router.query.userId
  const formik = useFormikContext<{
    profileId: number
  }>()

  const { data: userCreate, isLoading } = useQueryUser(locale, {
    enabled: type === 'user'
  })
  const { data: profileFreelancerCreate, isLoading: freelancerLoading } =
    useQueryMyProfileFreelancer({
      enabled: type === 'freelancer'
    })
  const { data: profileCompanyCreate, isLoading: companyLoading } =
    useQueryMyProfileCompany({
      enabled: type === 'company'
    })
  const { data: profileFactoryCreate, isLoading: factoryLoading } =
    useQueryMyProfileFactory({
      enabled: type === 'factory' || !type
    })

  const user = props.userPage ? props.projectsProfile : userCreate
  const profileFreelancer = props.userPage
    ? props.projectsProfile
    : profileFreelancerCreate
  const profileCompany = props.userPage
    ? props.projectsProfile
    : profileCompanyCreate
  const profileFactory = props.userPage
    ? props.projectsProfile
    : profileFactoryCreate

  useEffect(() => {
    if (type === 'freelancer' && !props.userPage)
      formik.setFieldValue('profileId', profileFreelancer?.id)

    if (type === 'company' && !props.userPage)
      formik.setFieldValue('profileId', profileCompany?.id)

    if (type === 'user' && !isLoading && !props.userPage)
      formik.setFieldValue('profileId', null)

    if ((type === 'factory' || !type) && !props.userPage)
      formik.setFieldValue('profileId', profileFactory?.id)
  }, [profileCompany?.id, profileFreelancer?.id, profileFactory?.id, type])

  const ratingFreelancerLastNumber = profileFreelancer?.rating
    ? profileFreelancer?.rating % 10
    : 0
  const ratingCompanyLastNumber = profileCompany?.rating
    ? profileCompany.rating % 10
    : 0
  const ratingFactoryLastNumber = profileFactory?.rating
    ? profileFactory.rating % 10
    : 0
  const classes = useProfileDetailsStyles()

  if (
    isLoading ||
    freelancerLoading ||
    companyLoading ||
    factoryLoading ||
    props.loadingProfile
  ) {
    return <ContactFormSkeleton />
  }

  return (
    <>
      <Card style={{ position: 'relative' }}>
        {type === 'user' ? (
          <CardContent>
            <div className={classes.cardTop} style={{ margin: '4px 0 14px 0' }}>
              {user?.avatarUrl &&
              !user.avatarUrl?.includes('lorempixel.com') ? (
                <Image
                  className={classes.avatarImage}
                  src={user.avatarUrl}
                  width={160}
                  height={160}
                  alt=""
                />
              ) : (
                <div className={classes.defaultImg}>
                  {user?.name && user.name[0]}
                </div>
              )}
            </div>
            <Typography
              variant="h1"
              align="center"
              gutterBottom
              style={{
                fontSize: '1.5rem',
                fontWeight: 400,
                lineHeight: 1.334,
                letterSpacing: '0em'
              }}
            >
              {user?.name}
            </Typography>
          </CardContent>
        ) : type === 'freelancer' ? (
          <>
            {profileFreelancer?.isPremium && (
              <div className={classes.premium}>
                <Typography className={classes.premiumTitle}>
                  Premium
                </Typography>
                {/* <CrownIcon /> */}
              </div>
            )}
            <CardContent>
              <div className={classes.cardTop}>
                {profileFreelancer?.avatarUrl &&
                !profileFreelancer?.avatarUrl?.includes('lorempixel.com') ? (
                  <Image
                    className={classes.avatarImage}
                    src={profileFreelancer?.avatarUrl}
                    width={176}
                    height={176}
                    alt=""
                  />
                ) : (
                  <div className={classes.defaultImg}>
                    {profileFreelancer?.fullName &&
                      profileFreelancer.fullName[0]}
                  </div>
                )}
                {profileFreelancer?.isVerified && (
                  <div className={classes.onlineIco}>
                    <OnlineIcon />
                  </div>
                )}
              </div>
              {profileFreelancer?.online && (
                <div className={classes.onlineTitle}>
                  <Typography
                    variant="body2"
                    align="center"
                    style={{ color: '#2E86BD' }}
                  >
                    {translate?.['blog-site']?.online ?? 'В сети'}
                  </Typography>
                </div>
              )}
              <Typography
                variant="h1"
                align="center"
                gutterBottom
                style={{
                  fontSize: '1.5rem',
                  fontWeight: 400,
                  lineHeight: 1.334,
                  letterSpacing: '0em'
                }}
              >
                {profileFreelancer?.fullName}
              </Typography>
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  flexDirection: 'column'
                }}
              >
                {profileFreelancer?.mainActivitySpecializations?.map(
                  (item: {
                    id: React.Key | null | undefined
                    name:
                      | boolean
                      | React.ReactChild
                      | React.ReactFragment
                      | React.ReactPortal
                      | null
                      | undefined
                  }) => (
                    <Typography key={item.id} variant="body1" align="center">
                      {item.name}
                    </Typography>
                  )
                )}
              </div>
              <Box
                display="flex"
                justifyContent="center"
                alignItems="center"
                gridGap={14}
                mt={'10px'}
              >
                {profileFreelancer?.rating !== undefined && (
                  <Typography variant="body1" align="center">
                    <b style={{ fontWeight: 600 }}>
                      {locale === 'ru' ? 'Рейтинг' : 'Rating'}:
                    </b>{' '}
                    {profileFreelancer.rating}{' '}
                    {profileFreelancer.rating
                      ? ratingFreelancerLastNumber === 1 &&
                        profileFreelancer.rating !== 11
                        ? locale === 'ru'
                          ? 'балл'
                          : 'point'
                        : ratingFreelancerLastNumber >= 2 &&
                          ratingFreelancerLastNumber <= 4 &&
                          profileFreelancer.rating !== 12 &&
                          profileFreelancer.rating !== 13 &&
                          profileFreelancer.rating !== 14
                        ? locale === 'ru'
                          ? 'балла'
                          : 'points'
                        : locale === 'ru'
                        ? 'баллов'
                        : 'points'
                      : locale === 'ru'
                      ? 'баллов'
                      : 'points'}
                  </Typography>
                )}
                <Button
                  variant="text"
                  color="primary"
                  className={classes.reviewsButton}
                  onClick={() => setIsReviewsModalOpened((prev) => !prev)}
                >
                  <b style={{ fontWeight: 600 }}>
                    {locale === 'ru' ? 'Отзывы' : 'Reviews'}
                  </b>
                  ({profileFreelancer?.review_count || 0})
                </Button>
              </Box>
            </CardContent>
            <CardActions className={classes.btnGroup}>
              <Link
                href={
                  locale === 'ru'
                    ? `${url.job}/ru` +
                      `/profile-specialist/${profileFreelancer?.slug_name}/${profileFreelancer?.id}`
                    : url.job +
                      `/profile-specialist/${profileFreelancer?.slug_name}/${profileFreelancer?.id}`
                }
                passHref
              >
                <Button
                  variant="contained"
                  color="secondary"
                  style={{ textTransform: 'none' }}
                >
                  {translate?.['profile-title']}
                </Button>
              </Link>
            </CardActions>
          </>
        ) : type === 'company' ? (
          <>
            {profileCompany?.isPremium && (
              <div className={classes.premium}>
                <Typography className={classes.premiumTitle}>
                  Premium
                </Typography>
                {/* <CrownIcon /> */}
              </div>
            )}
            <CardContent>
              <div className={classes.cardTop}>
                {profileCompany?.avatarUrl &&
                !profileCompany?.avatarUrl?.includes('lorempixel.com') ? (
                  <Image
                    className={classes.avatarImage}
                    src={profileCompany?.avatarUrl}
                    width={176}
                    height={176}
                    alt=""
                  />
                ) : (
                  <div className={classes.defaultImg}>
                    {profileCompany?.name && profileCompany.name[0]}
                  </div>
                )}
                {profileCompany?.isVerified && (
                  <div className={classes.onlineIco}>
                    <OnlineIcon />
                  </div>
                )}
              </div>
              {profileCompany?.online && (
                <div className={classes.onlineTitle}>
                  <Typography
                    variant="body2"
                    align="center"
                    style={{ color: '#2E86BD' }}
                  >
                    {translate?.['blog-site']?.online ?? 'В сети'}
                  </Typography>
                </div>
              )}
              <Typography
                variant="h1"
                align="center"
                gutterBottom
                style={{
                  fontSize: '1.5rem',
                  fontWeight: 400,
                  lineHeight: 1.334,
                  letterSpacing: '0em'
                }}
              >
                {profileCompany?.name}
              </Typography>
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  flexDirection: 'column'
                }}
              >
                {profileCompany?.mainActivitySpecializations?.map(
                  (item: {
                    id: React.Key | null | undefined
                    name:
                      | boolean
                      | React.ReactChild
                      | React.ReactFragment
                      | React.ReactPortal
                      | null
                      | undefined
                  }) => (
                    <Typography key={item.id} variant="body1" align="center">
                      {item.name}
                    </Typography>
                  )
                )}
              </div>
              <Box
                display="flex"
                justifyContent="center"
                alignItems="center"
                gridGap={14}
                mt={'10px'}
              >
                {profileCompany?.rating !== undefined && (
                  <Typography variant="body1" align="center">
                    <b style={{ fontWeight: 600 }}>
                      {locale === 'ru' ? 'Рейтинг' : 'Rating'}:
                    </b>{' '}
                    {profileCompany.rating}{' '}
                    {profileCompany.rating
                      ? ratingCompanyLastNumber === 1 &&
                        profileCompany.rating !== 11
                        ? locale === 'ru'
                          ? 'балл'
                          : 'point'
                        : ratingCompanyLastNumber >= 2 &&
                          ratingCompanyLastNumber <= 4 &&
                          profileCompany.rating !== 12 &&
                          profileCompany.rating !== 13 &&
                          profileCompany.rating !== 14
                        ? locale === 'ru'
                          ? 'балла'
                          : 'points'
                        : locale === 'ru'
                        ? 'баллов'
                        : 'points'
                      : locale === 'ru'
                      ? 'баллов'
                      : 'points'}
                  </Typography>
                )}
                <Button
                  variant="text"
                  color="primary"
                  className={classes.reviewsButton}
                  onClick={() => setIsReviewsModalOpened((prev) => !prev)}
                >
                  <b style={{ fontWeight: 600 }}>
                    {locale === 'ru' ? 'Отзывы' : 'Reviews'}
                  </b>
                  ({profileCompany?.review_count || 0})
                </Button>
              </Box>
            </CardContent>
            <CardActions className={classes.btnGroup}>
              <Link
                href={
                  locale === 'ru'
                    ? `${url.job}/ru` +
                      `/profile-company/${profileCompany?.slug_name}/${profileCompany?.id}`
                    : url.job +
                      `/profile-company/${profileCompany?.slug_name}/${profileCompany?.id}`
                }
                passHref
              >
                <Button
                  variant="contained"
                  color="secondary"
                  style={{ textTransform: 'none' }}
                >
                  {translate?.['profile-title']}
                </Button>
              </Link>
            </CardActions>
          </>
        ) : (
          <>
            {profileFactory?.isPremium && (
              <div className={classes.premium}>
                <Typography className={classes.premiumTitle}>
                  Premium
                </Typography>
                {/* <CrownIcon /> */}
              </div>
            )}
            <CardContent>
              <div className={classes.cardTop}>
                {profileFactory?.avatarUrl &&
                !profileFactory?.avatarUrl?.includes('lorempixel.com') ? (
                  <Image
                    className={classes.avatarImage}
                    src={profileFactory?.avatarUrl}
                    width={176}
                    height={176}
                    alt=""
                  />
                ) : (
                  <div className={classes.defaultImg}>
                    {profileFactory?.name && profileFactory.name[0]}
                  </div>
                )}
                {profileFactory?.isVerified && (
                  <div className={classes.onlineIco}>
                    <OnlineIcon />
                  </div>
                )}
              </div>
              {profileFactory?.online && (
                <div className={classes.onlineTitle}>
                  <Typography
                    variant="body2"
                    align="center"
                    style={{ color: '#2E86BD' }}
                  >
                    {translate?.['blog-site']?.online ?? 'В сети'}
                  </Typography>
                </div>
              )}
              <Typography
                variant="h1"
                align="center"
                gutterBottom
                style={{
                  fontSize: '1.5rem',
                  fontWeight: 400,
                  lineHeight: 1.334,
                  letterSpacing: '0em'
                }}
              >
                {profileFactory?.name}
              </Typography>
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  flexDirection: 'column'
                }}
              >
                {profileFactory?.mainActivitySpecializations?.map(
                  (item: {
                    id: React.Key | null | undefined
                    name:
                      | boolean
                      | React.ReactChild
                      | React.ReactFragment
                      | React.ReactPortal
                      | null
                      | undefined
                  }) => (
                    <Typography key={item.id} variant="body1" align="center">
                      {item.name}
                    </Typography>
                  )
                )}
              </div>
              <Box
                display="flex"
                justifyContent="center"
                alignItems="center"
                gridGap={14}
                mt={'10px'}
              >
                {profileFactory?.rating !== undefined && (
                  <Typography variant="body1" align="center">
                    <b style={{ fontWeight: 600 }}>
                      {locale === 'ru' ? 'Рейтинг' : 'Rating'}:
                    </b>{' '}
                    {profileFactory.rating}{' '}
                    {profileFactory.rating
                      ? ratingFactoryLastNumber === 1 &&
                        profileFactory.rating !== 11
                        ? locale === 'ru'
                          ? 'балл'
                          : 'point'
                        : ratingFactoryLastNumber >= 2 &&
                          ratingFactoryLastNumber <= 4 &&
                          profileFactory.rating !== 12 &&
                          profileFactory.rating !== 13 &&
                          profileFactory.rating !== 14
                        ? locale === 'ru'
                          ? 'балла'
                          : 'points'
                        : locale === 'ru'
                        ? 'баллов'
                        : 'points'
                      : locale === 'ru'
                      ? 'баллов'
                      : 'points'}
                  </Typography>
                )}
                <Button
                  variant="text"
                  color="primary"
                  className={classes.reviewsButton}
                  onClick={() => setIsReviewsModalOpened((prev) => !prev)}
                >
                  <b style={{ fontWeight: 600 }}>
                    {locale === 'ru' ? 'Отзывы' : 'Reviews'}
                  </b>
                  ({profileFactory?.review_count || 0})
                </Button>
              </Box>
            </CardContent>
            <CardActions className={classes.btnGroup}>
              <Link
                href={
                  locale === 'ru'
                    ? `${url.job}/ru` +
                      `/profile-factory/${profileFactory?.slug_name}/${profileFactory?.id}`
                    : url.job +
                      `/profile-factory/${profileFactory?.slug_name}/${profileFactory?.id}`
                }
                passHref
              >
                <Button
                  variant="contained"
                  color="secondary"
                  style={{ textTransform: 'none' }}
                >
                  {translate?.['profile-title']}
                </Button>
              </Link>
            </CardActions>
          </>
        )}
        <ReviewsModal
          open={isReviewsModalOpened}
          profileName={
            type === 'freelancer'
              ? profileFreelancer?.fullName
              : type === 'company'
              ? profileCompany?.name
              : profileFactory?.name
          }
          handleClose={() => setIsReviewsModalOpened(false)}
          profileId={
            type === 'freelancer'
              ? profileFreelancer?.id
              : type === 'company'
              ? profileCompany?.id
              : profileFactory?.id
          }
          profileType={
            type === 'freelancer'
              ? 'profileSpecialist'
              : type === 'company'
              ? 'profileCompany'
              : 'profileFactory'
          }
          profileSlugName={
            type === 'freelancer'
              ? profileFreelancer?.slug_name
              : type === 'company'
              ? profileCompany?.slug_name
              : profileCompany?.slug_name
          }
        />
      </Card>
      {!props.create && type === 'user' && (user?.email || user?.phone) && (
        <ProfileContactsUser user={user} translate={translate} />
      )}
      <ProfilePublications
        type={type}
        user={user}
        profileFreelancer={profileFreelancer}
        profileCompany={profileCompany}
        profileFactory={profileFactory}
      />
      {!props.create && type !== 'user' && (
        <ProfileInfo
          type={type}
          profileFreelancer={profileFreelancer}
          profileCompany={profileCompany}
          profileFactory={profileFactory}
        />
      )}
      {((type === 'freelancer' && profileFreelancer?.aboutMe) ||
        (type === 'company' && profileCompany?.about) ||
        ((type === 'factory' || !type) && profileFactory?.about)) &&
        !props.create && (
          <ProfileAbout
            type={type}
            profileFreelancer={profileFreelancer}
            profileCompany={profileCompany}
            profileFactory={profileFactory}
          />
        )}
      {!props.create && type !== 'user' && (
        <ProfileSpeciality
          type={type}
          profileFreelancer={profileFreelancer}
          profileCompany={profileCompany}
          profileFactory={profileFactory}
        />
      )}
      {!props.create && profileFactory?.structure && (
        <ProfileStructure profileFactory={profileFactory} />
      )}
      {((type === 'freelancer' &&
        profileFreelancer?.skills &&
        profileFreelancer?.skills?.length > 0) ||
        (type === 'company' &&
          profileCompany?.skills &&
          profileCompany?.skills?.length > 0)) &&
        !props.create && (
          <ProfileProfessional
            type={type}
            profileFreelancer={profileFreelancer}
            profileCompany={profileCompany}
          />
        )}
      {type === 'freelancer' &&
        profileFreelancer?.condition?.employments &&
        profileFreelancer?.condition?.employments.length > 0 &&
        !props.create && (
          <ProfileEmployment profileFreelancer={profileFreelancer} />
        )}
      {type === 'freelancer' &&
        profileFreelancer?.features &&
        profileFreelancer?.features.length > 0 &&
        !props.create && (
          <ProfileFeatures profileFreelancer={profileFreelancer} />
        )}
      {!props.create &&
        (profileFactory?.socialNetwork ||
          profileFreelancer?.socialNetwork ||
          profileCompany?.socialNetwork) && (
          <ProfileSocial
            profileFactory={profileFactory}
            profileFreelancer={profileFreelancer}
            profileCompany={profileCompany}
            type={type}
          />
        )}
    </>
  )
}
